import React from 'react';

const ThruWayDetails = () => {
  const details = [
    {
      title: 'Station Connections',
      description: 'If your journey involves a stop at a station within the designated area, we provide complimentary bus service to connect you.'
    },
    {
      title: 'Pre-Purchased Tickets',
      description: 'Unable to travel to the station but already purchased your ticket? Your fee will be waived, and bus travel to the designated station is complimentary.'
    },
    {
      title: 'Train Breakdown Support',
      description: 'In the event of a train breakdown, AG&W Thru-Way will transport you to the next available station to continue your journey without additional ticket costs.'
    },
    {
      title: 'Important Reminder',
      description: 'Please retain your train ticket or email with E-Ticket to guarantee your eligibility to ride Thru-Way Connections.'
    }
  ];

  return (
    <div className="thruway-details">
      {details.map((detail) => (
        <div key={detail.title} className="thruway-card">
          <h4>{detail.title}</h4>
          <p>{detail.description}</p>
        </div>
      ))}
    </div>
  );
};

export default ThruWayDetails;
